module.exports = __webpack_public_path__ + "static/img/FullLogo.5427eb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gmn/FullLogo.png
// module id = LlB0
// module chunks = 1